var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.style)},[(_vm.src)?_c('img',{attrs:{"src":_vm.url,"alt":""}}):_vm._e(),_c('div',{staticClass:"default",style:({ borderRadius:this.border})},[_c('i',{staticClass:"el-icon-loading"})])])}
var staticRenderFns = []

export { render, staticRenderFns }